export default {
  fondsEdit: {
    component: () =>
      import(
        /* webpackChunkName: "statistic_detail" */ "@/mods/setting/fondsManage/detailView/FondsEdit"
      ),
  },
};
